<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="7">
        
        <!-- Inline Presentation Mode -->
        <v-row justify="center">
          <v-col cols="12" md="10">
            
        <!-- Webinar-Info über dem Video -->
        <div class="mb-3">
          <h1 class="text-red" v-if="terminData.beendet">Webinar wurde beendet</h1>
          <span v-if="terminData && terminData.webi_title">
            <h3 style="color: #3d1b70;">{{terminData.webi_title}} </h3>
            <div style="color: #666; font-size: 14px;">Beginn: {{ terminData.beginn }} | Dozent: {{ terminData.dozent }}</div>
          </span>
        </div>
        
        <div :style="{ 
          position: 'relative', 
          width: '100%',
          marginLeft: baseStore.isMobile ? '0' : '0px'
        }">
          
          <!-- Wenn Präsentation noch nicht gestartet: Admin Video füllt ganzen Container -->
          <div v-if="!presentationStarted" 
               id="admin-videos-fullsize" 
               :style="{
                 width: '100%',
                 aspectRatio: '16/9',
                 background: '#000',
                 borderRadius: '0px',
                 position: 'relative'
               }">
            
            <!-- Overlay wenn kein Admin-Video -->
            <div v-if="!hasAdminVideo" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); display: flex; align-items: center; justify-content: center; flex-direction: column; border-radius: 0px; z-index: 5;">
              <v-icon size="100" color="white" class="mb-6" style="opacity: 0.9;">mdi-video-off</v-icon>
             <span v-if="!terminData.isStarted && terminData.open && !startButtonPressed">
                <div style="color: white; font-size: 36px; font-weight: bold; text-align: center; padding: 30px; letter-spacing: 1px;">
                  Das Webinar wird um {{ terminData.beginn }} Uhr gestartet
                  <div v-if="baseStore.isMobile" style="color: rgba(255,255,255,0.8); font-size: 18px; margin-top: 8px; margin-bottom: 32px;">
                 Zum starten klicken Sie auf "Webinar jetzt starten"
                </div>
                </div>
               
              </span>
              <span v-if="terminData.isStarted && terminData.open && !startButtonPressed">
                <div style="color: white; font-size: 36px; font-weight: bold; text-align: center; padding: 20px; letter-spacing: 1px;">
                  Das Webinar ist bereits gestartet
                </div>
                <div v-if="baseStore.isMobile" style="color: rgba(255,255,255,0.8); font-size: 18px; margin-top: 8px; margin-bottom: 32px;">
                 Klicken Sie auf "Webinar jetzt starten" 
                </div>
                </span>
                <span v-if="!terminData.isStarted && terminData.open && startButtonPressed">
                <div style="color: white; font-size: 36px; font-weight: bold; text-align: center; padding: 20px; letter-spacing: 1px;">
                  Bitte haben Sie etwas Geduld
                  <div v-if="baseStore.isMobile" style="color: rgba(255,255,255,0.8); font-size: 18px; margin-top: 8px; margin-bottom: 32px;">
                 Das Webinar wird in Kürze gestartet
                </div>
                </div>
              
              </span>
              <v-btn 
                size="x-large" 
                color="#3d1b70" 
                variant="elevated"
                prepend-icon="mdi-play-circle"
                @click="startWebinar"
                style="min-width: 250px; font-size: 18px; font-weight: bold; box-shadow: 0 4px 20px rgba(76, 175, 80, 0.4);"
              >
                Webinar jetzt starten
              </v-btn>
            </div>
            
            <!-- Reaktions-Animation Overlay -->
            <transition name="reaction-fade">
              <div v-if="reactionAnimation.visible" 
                   style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; z-index: 100; pointer-events: none;">
                <v-icon 
                  :color="reactionAnimation.color" 
                  size="200"
                  class="reaction-pulse">
                  {{ reactionAnimation.icon }}
                </v-icon>
              </div>
            </transition>
            
            <!-- Audience Video - unten rechts als Overlay (auch ohne Präsentation) -->
            <div id="audience-video-inline-fullsize" 
                 :style="{
                   position: 'absolute',
                   bottom: '15px',
                   right: '15px',
                   width: '200px',
                   height: '150px',
                   background: '#000',
                   borderRadius: '0',
                   border: '2px solid #fff',
                   boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                   zIndex: 8,
                   display: showInlineVideoIdentity ? 'block' : 'none'
                 }">
            </div>
          </div>
          
          <!-- Wenn Präsentation gestartet: Slides als Hauptinhalt mit Admin Video als Overlay -->
          <template v-if="presentationStarted">
            <div :style="{
              width: '100%',
              aspectRatio: '16/9',
              background: '#000',
              position: 'relative'
            }">
              <!-- Zentrale Slides (Vollgröße) -->
              <img v-if="activePictureBroadCast.type == 'picture'" 
                   style="width: 100%; height: 100%; object-fit: contain;" 
                   :src="`/videos/webinar${slideShowNumber}/slides/${activePictureBroadCast.url}`">
              
              <video v-show="activePictureBroadCast.type == 'video'" 
                     ref="audienceVideoInline" 
                     style="width: 100%; height: 100%; object-fit: contain;" 
                     :src="`/videos/webinar4/slides/${activePictureBroadCast.url}`" 
                     controls 
                     preload="auto">
                Ihr Browser unterstützt das Video-Element nicht.
              </video>
              
              <!-- Versteckte Videos und Bilder zum Vorladen -->
              <div style="display: none;">
            <video v-if="currentWebinarSlides && currentWebinarSlides[1] && currentWebinarSlides[1].type === 'video'" 
                   :src="`/videos/webinar${slideShowNumber}/slides/${currentWebinarSlides[1].url}`" 
                       preload="auto"></video>
            <video v-if="activePictureBroadCast.type === 'video' && activePictureBroadCast.url !== (currentWebinarSlides[1] && currentWebinarSlides[1].url)" 
                       :src="`/videos/webinar${slideShowNumber}/slides/${activePictureBroadCast.url}`" 
                       preload="auto"></video>
                <video v-for="slide in getUpcomingVideoSlides()" :key="slide.url" :src="`/videos/webinar${slideShowNumber}/slides/${slide.url}`" preload="metadata"></video>
                <img v-for="slide in getUpcomingImageSlides()" :key="slide.url" :src="`/videos/webinar${slideShowNumber}/slides/${slide.url}`" />
            </div>
            
            <!-- Admin Video - rechts oben als kleines Overlay (200px) -->
              <div v-if="hasAdminVideo" 
                 id="admin-videos-inline" 
                 style="position: absolute; top: 15px; right: 15px; width: 200px; height: 150px; background: #000; border-radius: 0; border: 2px solid #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.3); z-index: 8;">
            </div>
              
              <!-- Audience Video - unten rechts als kleines Overlay (wenn showInlineVideoIdentity gesetzt) -->
              <div id="audience-video-inline" 
                   :style="{
                     position: 'absolute',
                     bottom: '15px',
                     right: '15px',
                     width: '200px',
                     height: '150px',
                     background: '#000',
                     borderRadius: '0',
                     border: '2px solid #fff',
                     boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                     zIndex: 8,
                     display: showInlineVideoIdentity ? 'block' : 'none'
                   }">
              </div>
              
              <!-- Reaktions-Animation Overlay -->
              <transition name="reaction-fade">
                <div v-if="reactionAnimation.visible" 
                     style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; z-index: 100; pointer-events: none;">
                  <v-icon 
                    :color="reactionAnimation.color" 
                    size="200"
                    class="reaction-pulse">
                    {{ reactionAnimation.icon }}
                  </v-icon>
                </div>
              </transition>
            </div>
          </template>
          
          <!-- Badges vertikal links oben (nur Desktop) -->
          <div v-if="!baseStore.isMobile" style="position: absolute; top: 15px; left: 15px; z-index: 10; display: flex; flex-direction: column; gap: 10px;">
            <!-- Teilnehmer Badge -->
            <div v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0" 
                  style="background: rgba(33, 150, 243, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-account-group</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ allTeilnehmerInRoom.length }}</span>
            </div>
            
            <!-- Fragen Badge -->
            <div v-if="webinarStats && webinarStats.fragen > 0" 
                  style="background: rgba(33, 150, 243, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-help-circle</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.fragen }}</span>
            </div>
            
            <!-- Danke Badge -->
            <div v-if="webinarStats && webinarStats.danke > 0" 
                  style="background: rgba(244, 67, 54, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-heart</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.danke }}</span>
            </div>
            
            <!-- Interessant Badge -->
            <div v-if="webinarStats && webinarStats.interessant > 0" 
                  style="background: rgba(255, 152, 0, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
              <v-icon color="white" size="24">mdi-fire</v-icon>
              <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.interessant }}</span>
            </div>
          </div>
          
          <!-- WTB Logo rechts oben (nur Desktop) -->
          <div v-if="!baseStore.isMobile" style="position: absolute; top: 15px; right: 20px; width: 40px; height: 80px; background: #3166a5; display: flex; align-items: flex-end; justify-content: center; padding-bottom: 4px; z-index: 10;">
            <span style="color: white; font-size: 14px; font-weight: bold;">WTB</span>
          </div>
        </div>
        
        </v-col>
        </v-row>
        
        <!-- Badges für Mobile (horizontal als Chips) -->
        <v-row v-if="baseStore.isMobile" dense class="mt-2 mb-2" justify="center">
          <v-col cols="auto" v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0">
            <v-chip color="blue" variant="elevated">
              <v-icon start size="small">mdi-account-group</v-icon>
              {{ allTeilnehmerInRoom.length }}
            </v-chip>
          </v-col>
          <v-col cols="auto" v-if="webinarStats && webinarStats.fragen > 0">
            <v-chip color="blue" variant="elevated">
              <v-icon start size="small">mdi-help-circle</v-icon>
              {{ webinarStats.fragen }}
            </v-chip>
          </v-col>
          <v-col cols="auto" v-if="webinarStats && webinarStats.danke > 0">
            <v-chip color="white" variant="elevated" style="border: 2px solid #F44336;">
              <v-icon start size="small" color="#F44336">mdi-heart</v-icon>
              <span style="color: #333;">{{ webinarStats.danke }}</span>
            </v-chip>
          </v-col>
          <v-col cols="auto" v-if="webinarStats && webinarStats.interessant > 0">
            <v-chip color="orange" variant="elevated">
              <v-icon start size="small">mdi-fire</v-icon>
              {{ webinarStats.interessant }}
            </v-chip>
          </v-col>
        </v-row>
        
        <!-- Teilnehmer Overlay -->
        <div id="fragenOverlay" 
             class="draggable-fragen-overlay" 
             :style="fragenOverlayStyle"
             ref="fragenOverlayRef">
             
          <!-- Overlay Header -->
          <div class="fragen-overlay-header" @mousedown="startFragenDrag">
            <span>Teilnehmer ({{ allTeilnehmerInRoom.length }})</span>
            <v-btn @click="toggleFragenOverlay" class="fragen-overlay-minimize" icon size="small" variant="text">
              <v-icon color="white">{{ fragenOverlayMinimized ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </div>
          
          <!-- Overlay Content -->
          <div class="fragen-overlay-content" v-if="!fragenOverlayMinimized">
            <h3 v-if="!allTeilnehmerInRoom || allTeilnehmerInRoom.length === 0">Es sind noch keine Teilnehmer eingeloggt</h3>
            <v-row v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0" class="mt-4">
              <v-col cols="12">
                <v-row>
                  <v-col cols="11">
                    <div v-for="item in getParticipantsBroadcastStatus()" :key="item.identity" class="mb-2 py-2" style="border-bottom: 1px solid #ccc;">
                      <v-row class="align-center">
                        <v-col cols="5">
                          <h4>{{ getNameFromTeilnehmer(item.identity,'name') }}
                            <h4 v-if="getNameFromTeilnehmer(item.identity,'admin') == 1" class="text-green">Admin</h4>
                            <h4 v-else-if="getNameFromTeilnehmer(item.identity,'admin') == 2" class="text-green">Co-Admin</h4>
                          </h4>
                        </v-col>
                        <v-col cols="3" class="d-flex align-center" style="gap: 8px;">
                          <v-icon v-if="!item.isBroadcasting && (getNameFromTeilnehmer(item.identity,'admin') == 2 || getNameFromTeilnehmer(item.identity,'admin') == 0)" color="green">mdi-eye</v-icon>
                          <v-icon :color="item.hasVideo ? 'green' : 'red'">{{ item.hasVideo ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
                          <v-icon :color="item.hasAudio ? 'green' : 'red'">{{ item.hasAudio ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
                        </v-col>
                        <v-col cols="4">
                          <span v-if="(getNameFromTeilnehmer(item.identity,'admin') == 2 || getNameFromTeilnehmer(item.identity,'admin') == 0)">
                            <v-btn v-if="AUDIENCE_LIVE_ENABLED && !item.isBroadcasting" @click="setUserVideoOnDirect(1,item)" class="mr-2" color="green">live</v-btn>
                            <v-btn v-if="item.isBroadcasting" @click="setUserVideoOnDirect(0,item)" class="mr-2" color="red">off</v-btn>
                            <v-btn
                              v-if="item.isBroadcasting && item.hasVideo"
                              variant="text"
                              icon
                              :color="currentInlineVideoIdentity === item.identity ? 'red' : 'primary'"
                              :title="currentInlineVideoIdentity === item.identity ? 'Inline-Video ausblenden' : 'Inline-Video anzeigen'"
                              @click="toggleInlineVideo(item.identity)"
                            >
                              <v-icon>{{ currentInlineVideoIdentity === item.identity ? 'mdi-television-off' : 'mdi-television' }}</v-icon>
                            </v-btn>
                          </span>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
        
        <!-- Active Fragen Overlay -->
        <div
             v-if="!showUserChat"
             id="activeFragen" 
             class="draggable-active-fragen-overlay" 
             :style="activeFragenOverlayStyle"
             ref="activeFragenOverlayRef">
             
          <!-- Active Fragen Overlay Header für Drag -->
          <div class="active-fragen-overlay-header" @mousedown="startActiveFragenDrag">
            <span v-if="teilnehmerFragen.length > 0">Teilnehmer-Fragen ({{ teilnehmerFragen.length }})</span>
            <span v-if="teilnehmerFragen.length === 0">Es wurde noch keine Frage gestellt</span>
            <v-btn @click="toggleActiveFragenOverlay" class="active-fragen-overlay-minimize" icon size="small" variant="text">
              <v-icon color="white">{{ activeFragenOverlayMinimized ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </div>
          
          <!-- Active Fragen Overlay Content -->
          <div class="active-fragen-overlay-content" v-if="!activeFragenOverlayMinimized">
            <div v-if="teilnehmerFragen.length > 0" style="width: 100%;">
              <div class="my-8 pb-2" style="border-bottom: 1px solid #ccc;background-color: #f2f2f2;" v-for="item in teilnehmerFragen" :key="item.id">
                <v-row>
                  <v-col cols="1">
                    <v-icon :color="isUserOnline(item.teilnehmerid) ? 'green' : 'grey'" style="font-size: 33px;" :class="isUserOnline(item.teilnehmerid) ? 'pulsing-heart' : ''">mdi-video</v-icon>
                  </v-col>
                  <v-col cols="7">
                    Frage gestellt vor <span class="text-green" v-if="item.vor < 2">{{ item.vor }} Minute</span><span v-if="item.vor >= 2">{{ item.vor }} Minuten</span> | {{ item.teilnehmerid }}
                    <h3>{{ item.name }}</h3>
                  </v-col>
                  <v-col cols="4">
                    <span v-if="!isUserOnline(item.teilnehmerid)">
                      <v-btn color="red" size="small">Offline</v-btn>
                    </span>
                    <span v-if="isUserOnline(item.teilnehmerid)">
                      <v-btn v-if="AUDIENCE_LIVE_ENABLED && item.video == 0" 
                             @click="setUserVideoOn(1, item)" 
                             class="mb-2" 
                             color="green" 
                             size="small"
                             style="width: 100%; height: 40px; font-size: 14px;">
                        live schalten
                      </v-btn>
                      <v-btn v-if="item.video == 1" 
                             @click="setUserVideoOn(0, item)" 
                             color="red"
                             size="small"
                             style="width: 100%; height: 40px; font-size: 14px;">
                        ausschalten
                      </v-btn>
                    </span>
                  </v-col>
                </v-row>
                
                <v-row class="pa-2">
                  <v-col cols="8">
                    <div style="background-color: #fff;" class="pa-4 ml-2">
                      <em>{{ item.frage }}</em>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <v-btn @click="SetStatusFrage(3, item)" class="mb-2" :color="item.status == 3 ? 'blue' : ''" size="small">Frage wurde beantwortet</v-btn><br>
                    <v-btn @click="SetStatusFrage(4, item)" :color="item.status == 4 ? 'red' : ''" size="small">Frage löschen</v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div> <!-- Ende activeFragen -->
        
        <!-- Reaktions-Button-Leiste -->
        <v-row justify="center">
          <v-col cols="12" md="10">
        <div class="mt-3" style="padding: 16px; background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); border-radius: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
          <v-row dense>
            <v-col cols="12">
              <div class="d-flex flex-wrap" style="gap: 8px;">
                <v-btn
                  class="flex-grow-1"
                  color="blue"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-human-greeting"
                  @click="sendReaction('userHallo')"
                  style="font-weight: bold;"
                >
                  Hallo
                </v-btn>

                <v-btn
                  class="flex-grow-1"
                  variant="elevated"
                  size="large"
                  @click="sendReaction('userDanke')"
                  style="font-weight: bold; background: white; color: #333;"
                >
                  <v-icon color="#F44336" class="mr-2">mdi-heart</v-icon>
                  Danke
                </v-btn>

                <v-btn
                  class="flex-grow-1"
                  color="orange"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-fire"
                  @click="sendReaction('userInteressant')"
                  style="font-weight: bold;"
                >
                  Interessant
                </v-btn>

                <v-btn
                  v-if="!showUserChat"
                  class="flex-grow-1"
                  color="primary"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-help-circle"
                  @click="showFrageDialog = true"
                  style="font-weight: bold;"
                >
                  Frage stellen
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="terminData.wteil_copilot == 1">
            <v-col cols="12" md="12">
          
              <v-btn
                variant="elevated"
                size="large"
                @click="sendReactionPilot('showDankeDialog')"
                block
                style="font-weight: bold; background: white; color: #333;"
              >
                <v-icon color="#F44336" class="mr-2">mdi-heart</v-icon>
                Danke Dialog für alle User einblenden
              </v-btn>
            </v-col>
          </v-row>
        </div>
        
        </v-col>
        </v-row>
        
        <v-row justify="center">
          <v-col cols="12" md="10">
        
          <!-- Mein Broadcast Bereich (nur Mobile) -->
          <div v-if="baseStore.isMobile && isMyBroadcasting" class="mb-4">
            <!-- Audio-Only: Zeige nur Audio-Indikator -->
            <div v-if="audioOnlyBroadcast" id="mein-broadcast-mobile" style="width: 100%; min-height: 200px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 0; margin-bottom: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
              <v-icon size="80" color="white" class="mb-4">mdi-microphone</v-icon>
              <div style="color: white; font-size: 24px; font-weight: bold;">Audio Live</div>
            </div>
            <!-- Video + Audio: Zeige Video-Container -->
            <div v-else id="mein-broadcast-mobile" style="width: 100%; min-height: 200px; background: #000; border-radius: 0; margin-bottom: 20px;"></div>
            
            <v-card class="mb-4" color="success" variant="tonal">
              <v-card-text>
                <div class="d-flex align-center justify-space-between mb-3">
                  <div class="d-flex align-center">
                    <v-icon color="success" class="mr-2">mdi-broadcast</v-icon>
                    <span class="text-h6">Sie sind "on Air"</span>
                  </div>
                </div>
                <div class="d-flex gap-2 mb-3">
                  <v-chip v-if="localVideoTrack" color="success" size="small">
                    <v-icon start size="small">mdi-video</v-icon>
                    Video
                  </v-chip>
                  <v-chip v-if="localAudioTrack" color="success" size="small">
                    <v-icon start size="small">mdi-microphone</v-icon>
                    Audio
                  </v-chip>
                </div>
                <v-btn 
                  color="red" 
                  variant="elevated" 
                  block
                  prepend-icon="mdi-stop-circle"
                  @click="stopMyBroadcast"
                  size="large"
                >
                  Übertragung beenden
                </v-btn>
              </v-card-text>
            </v-card>
          </div>
          <div v-else-if="baseStore.isMobile" id="mein-broadcast-mobile" style="display: none;"></div>
        
          <!-- Nur Audience Teilnehmer (nicht Admin, nicht ich selbst) -->
          
        <div v-for="participant in audienceParticipants" :key="participant.identity" v-show="hasVideo(participant.identity) || hasAudio(participant.identity)" style="margin-bottom: 20px;">

          <!-- Audio-Only Mode: Zeige Sprecher-Indikator -->
          <div v-if="!hasVideo(participant.identity) && hasAudio(participant.identity)" style="padding: 20px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 0; text-align: center;">
            <v-icon size="60" color="white" class="mb-3 pulse-animation">mdi-account-voice</v-icon>
            <div style="color: white; font-size: 24px; font-weight: bold;">{{ getNameFromTeilnehmer(participant.identity, 'name') }}</div>
            <div style="color: rgba(255,255,255,0.8); font-size: 14px; margin-top: 8px;">spricht gerade</div>
          </div>
          
          <!-- Video Mode: Zeige Video-Container mit Name-Overlay -->
          <div v-else :id="`video-container-${participant.identity.replace('_', '-')}`" style="padding: 10px; background: #fff; border-radius: 0; border: 1px solid #ddd; position: relative;">
            <div class="video-area" v-if="showInlineVideoIdentity !== participant.identity" style="width: 100%; height: 300px; background: #000; border-radius: 0; position: relative;">
              <!-- Name-Overlay im Video -->
              <div style="position: absolute; bottom: 0; left: 0; right: 0; background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%); padding: 12px; z-index: 10;">
                <div style="color: white; font-size: 18px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.8);">
                  {{ getNameFromTeilnehmer(participant.identity, 'name') }}
        </div>
           </div>
        </div>
         </div>
       </div>
  
    
       
        <!-- <div v-if="audienceParticipants.length === 0" style="padding: 20px; background: #d1ecf1; border-radius: 8px;">
          <p>ℹ️ Keine anderen Teilnehmer im Room</p>
         </div> -->
          </v-col>
        
        </v-row>

         
          
          <div v-if="showDebug">
          <h2>Teilnehmer ({{ allTeilnehmerInRoom.length }})</h2>
          <div style="max-height: 300px; overflow-y: auto; background: #fff; padding: 8px; border: 1px solid #ddd; margin-bottom: 20px;">
            <div v-if="allTeilnehmerInRoom.length === 0" style="padding: 8px; color: #666;">Keine Teilnehmer</div>
            <div v-else>
              <div v-for="(p, idx) in allTeilnehmerInRoom" :key="idx" style="padding: 8px; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <div style="font-weight: bold; color: #333;">
                    {{ p.identity }}
                    <span v-if="p.identity === myIdentity" style="color: #007bff; font-size: 12px;">(Ich)</span>
                    <span v-if="p.identity.startsWith('admin_')" style="color: #dc3545; font-size: 12px;">(Admin)</span>
            </div>
                  <div style="font-size: 12px; color: #666;">
                    📹 Video: {{ p.videoTracks }} | 🎤 Audio: {{ p.audioTracks }} | 💬 Data: {{ p.dataTracks }}
              </div>
            </div>
                <div>
                  <span v-if="p.videoTracks > 0 || p.audioTracks > 0" style="background: #28a745; color: white; padding: 2px 8px; border-radius: 0; font-size: 11px;">Broadcasting</span>
                  <span v-else style="background: #6c757d; color: white; padding: 2px 8px; border-radius: 0; font-size: 11px;">Watching</span>
             </div>
    </div>
     </div>
    </div>
    </div>

<div v-if="showDebug">
          <h2>Datatrack Nachrichten</h2>
          <div v-if="dataTrackMessages.length === 0" style="padding: 8px; color: #666;">Noch keine Nachrichten</div>
          <div v-else style="max-height: 400px; overflow-y: auto; background: #f8f9fa; padding: 8px; border: 1px solid #ddd;">
            <div v-for="(msg, idx) in dataTrackMessages" :key="idx" style="padding: 6px 8px; border-bottom: 1px solid #eee;">
              <div style="font-weight: bold; color: #333;">{{ msg.from }} <span style="font-weight: normal; color: #999;">{{ new Date(msg.ts).toLocaleTimeString() }}</span></div>
              <div v-if="msg.payload && msg.payload.type" style="font-size: 12px; color: #999;">{{ msg.payload.type }}</div>
              <div v-if="msg.payload && msg.payload.text">{{ msg.payload.text }}</div>
              <pre v-else style="white-space: pre-wrap; word-break: break-word; margin: 6px 0 0 0;">{{ msg.payload }}</pre>
            </div>
  </div> 
</div>
     

  </v-col>
  
  <!-- Rechte Spalte: Info-Bereich (nur Desktop) -->
  <v-col v-if="!baseStore.isMobile" cols="12" md="5">
 
      <!-- Mein Broadcast Bereich -->
      <div v-if="isMyBroadcasting" class="mb-4">
        <!-- Audio-Only: Zeige nur Audio-Indikator -->
        <div v-if="audioOnlyBroadcast" id="mein-broadcast" style="width: 100%; min-height: 200px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 0; margin-bottom: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <v-icon size="80" color="white" class="mb-4">mdi-microphone</v-icon>
          <div style="color: white; font-size: 24px; font-weight: bold;">Audio Live</div>
        </div>
        <!-- Video + Audio: Zeige Video-Container -->
        <div v-else id="mein-broadcast" style="width: 100%; min-height: 200px; background: #000; border-radius: 0; margin-bottom: 20px;"></div>
        
        <v-card class="mb-4" color="success" variant="tonal">
          <v-card-text>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-broadcast</v-icon>
                <span class="text-h6">Sie sind "on Air"</span>
              </div>
              <div class="d-flex gap-2">
                <v-chip v-if="localVideoTrack" color="success" size="small">
                  <v-icon start size="small">mdi-video</v-icon>
                  Video
                </v-chip>
                <v-chip v-if="localAudioTrack" color="success" size="small">
                  <v-icon start size="small">mdi-microphone</v-icon>
                  Audio
                </v-chip>
              </div>
            </div>
            <v-btn 
              color="red" 
              variant="elevated" 
              block
              prepend-icon="mdi-stop-circle"
              @click="stopMyBroadcast"
              size="large"
              class="mt-3"
            >
              Übertragung beenden
            </v-btn>
          </v-card-text>
        </v-card>
      </div>
      <div v-else id="mein-broadcast" style="display: none;"></div>
      
      <!-- Status-Infos wenn Webinar noch nicht gestartet -->
      <div v-if="!hasAdminVideo && !terminData.isStarted && terminData.open && !startButtonPressed">
        <v-icon size="64" color="primary" class="mb-4">mdi-information</v-icon>
        <h3 class="mb-3" style="color: #3d1b70;">Webinar startet bald</h3>
        <p class="text-body-1 mb-3">
          Das Webinar wird um <b>{{ terminData.beginn }} Uhr</b> gestartet.
        </p>
        <p class="text-body-2 text-grey-darken-1">
          Zum Starten klicken Sie auf "Webinar jetzt starten"
        </p>
      </div>
      
      <div v-if="!hasAdminVideo && terminData.isStarted && terminData.open && !startButtonPressed">
        <v-icon size="64" color="success" class="mb-4">mdi-play-circle</v-icon>
        <h3 class="mb-3" style="color: #3d1b70;">Webinar läuft bereits</h3>
        <p class="text-body-2 text-grey-darken-1">
          Klicken Sie auf "Webinar jetzt starten" um teilzunehmen.
        </p>
      </div>
      
      <div v-if="!hasAdminVideo && !terminData.isStarted && terminData.open && startButtonPressed">
        <v-icon size="64" color="warning" class="mb-4">mdi-clock-outline</v-icon>
        <h3 class="mb-3" style="color: #3d1b70;">Bitte haben Sie etwas Geduld</h3>
        <p class="text-body-2 text-grey-darken-1">
          Das Webinar wird in Kürze gestartet.
        </p>
      </div>
      


    

      <!-- User Chat -->
      <div v-if="showUserChat && isConnected" class="mt-6" style="border: 4px solid #f2f2f2; padding: 10px;">
        <h3 class="mb-2" style="color:#3d1b70;">Chat</h3>
        <div class="mb-2" style="max-height: 500px; overflow-y: auto;">
          <div v-if="chatMessages.length === 0" class="text-center text-grey">
            Noch keine Nachrichten im Chat
          </div>
          <div
            v-for="(msg, idx) in chatMessages"
            :key="idx"
            class="mb-2 pb-2 chat-message"
            :class="{ 'chat-message--me': msg.from === myIdentity }"
          >
            <div>
              <strong style="color:#3d1b70;">
                {{ msg.from === myIdentity ? 'Ich' : (msg.displayName || getNameFromTeilnehmer(msg.from, 'name')) }}
              </strong>
              <small class="text-grey-darken-1">
                · {{ new Date(msg.ts).toLocaleTimeString() }}
              </small>
            </div>
            <div class="text-body-2">
              {{ msg.text }}
            </div>
          </div>
        </div>

        <v-textarea
          v-model="chatInput"
          label="Schreiben Sie Ihre Nachricht hier und senden Sie sie mit Enter"
          rows="2"
          auto-grow
          hide-details
          @keydown.enter.prevent="sendChatMessage"
          class="mt-3"
        />
      </div>

      <div v-if="publicDataTrackMessages.length > 0" class="mt-12">
            <div 
              v-for="(msg, idx) in publicDataTrackMessages" 
              :key="idx" 
              style="display: flex; align-items: center; gap: 8px; padding: 6px 8px; border-bottom: 1px solid #eee;"
            >
              <template v-if="msg.type === 'newTeilnehmerRegistered'">
                <v-icon color="green">mdi-account-plus</v-icon>
                <span>jetzt auch dabei: <b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b></span>
              </template>
              <template v-if="msg.type === 'jetzLiveImWebinar'">
                <v-icon color="green">mdi-camera</v-icon>
                <span>jetzt live: <b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b></span>
              </template>
              <template v-if="msg.type === 'userDanke'">
                <v-icon color="red">mdi-heart</v-icon>
                <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> sagt Danke</span>
              </template>
              <template v-if="msg.type === 'userInteressant'">
                <v-icon color="orange">mdi-fire</v-icon>
                <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> findet es interessant</span>
              </template>
              <template v-if="msg.type === 'neueUserFragen'">
                <v-icon color="blue">mdi-help-circle</v-icon>
                <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> stellt eine Frage</span>
              </template>
              <template v-if="msg.type === 'userHallo'">
                <v-icon color="blue">mdi-human-greeting</v-icon>
                <span><b>{{ getNameFromTeilnehmer(msg.from,'name') }}</b> sagt Hallo</span>
              </template>
            </div>
          </div>
  </v-col>
  
</v-row>
  <v-dialog v-model="showFrageDialog" width="666" >
    <v-card class="pa-4">
      <v-row>
          <v-col cols="12" class="pl-4">
        <h2>Sie wollen eine Frage stellen?</h2>
        <p>Bitte geben Sie ein paar Stichworte zu Ihrer Frage an. </p>
        <v-textarea rows="2" v-model="frageTexte" label="Stichworte" />
        <v-btn width="100%" color="primary" @click="saveFrage">jetzt Frage stellen</v-btn>
        </v-col>
        </v-row>
      </v-card>
  </v-dialog>
  <v-dialog v-model="showDankeDialog" width="666" >
    <v-card class="pa-4">
      <v-row>
        <v-col cols="12" class="pl-4">
          <h2>Hat Ihnen das Webinar gefallen?</h2>
          <p>Wir freuen uns über Ihre Meinung bzw. ein kleines Danke. </p><br /><br />
          <v-textarea rows="3" v-model="dankeText" label="Ihre Meinung ist uns wichtig" bg-color="white" />
          <v-btn width="100%" color="primary" @click="sendDanke">jetzt Feedback speichern</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
  </v-container>
</template>

<script setup>
import { inject, ref, onMounted, onBeforeUnmount, markRaw, watch, shallowRef, nextTick, computed } from "vue";
const Video = require('twilio-video');
import { storeToRefs } from 'pinia';
import { useRoute } from "vue-router";
import { useUserStore } from '@/stores/userStore';
import { useWebinarStore } from '@/stores/webinarStore';
import { AUDIENCE_LIVE_ENABLED } from '@/services/webinarFeatures';

const baseCalls = inject('baseCalls');
const successStore = inject('successStore');
const updateDocumentHead = inject('updateDocumentHead');
const loaderStore = inject('loaderStore');
const baseStore = inject('baseStore')

const userStore = useUserStore();
const { userToken, userWebinarTerminId } = storeToRefs(userStore);
const webinarStore = useWebinarStore();
const route = useRoute();



// Basis-Refs
const room = shallowRef(null);
const audioOnlyBroadcast = ref(false);
const isConnected = ref(false);
const isConnecting = ref(false);
//const hasStartedSession = ref(false);
const token = ref('');
const webinarTerminId = ref(false);
const showDankeDialog = ref(false);

const terminData = ref({
  open: false,
  beendet: false,
  wter_id: null,
  id: null
});

// Teilnehmer-Tracking
const showInlineVideoIdentity = ref(null); // Welches Audience-Video soll im Admin-Container angezeigt werden?
const allTeilnehmerInRoom = ref([]);
const localDataTrack = shallowRef(null);
const localVideoTrack = shallowRef(null);
const localAudioTrack = shallowRef(null);
const isMyBroadcasting = ref(false);
const frageTexte = ref('');
const myIdentity = computed(() => `audience_${route.params.teilnahmeid}`);
const audienceIdentityHasVideo = ref({}); // identity -> boolean
const audienceIdentityHasAudio = ref({}); // identity -> boolean (für Audio-Only)
const hasAdminVideo = ref(false); // Admin sendet Video?
const dataTrackMessages = ref([]); // eingehende DataTrack Nachrichten
const publicDataTrackMessages = ref([]); // eingehende Public Track Nachrichten
const showFrageDialog = ref(false);
// User-Chat
const showUserChat = ref(true);
const chatMessages = ref([]);
const chatInput = ref('');

// Overlay-Variablen
const fragenOverlayRef = ref(null);
const fragenOverlayVisible = ref(true);
const fragenOverlayMinimized = ref(false);
const fragenOverlayPosition = ref({ x: 130, y: 100 });
const fragenIsDragging = ref(false);
const fragenDragStart = ref({ x: 0, y: 0 });

// Active Fragen Overlay Drag Variablen
const activeFragenOverlayRef = ref(null);
const activeFragenOverlayVisible = ref(true);
const activeFragenOverlayMinimized = ref(false);
const activeFragenOverlayPosition = ref({ x: 800, y: 100 });
const activeFragenIsDragging = ref(false);
const activeFragenDragStart = ref({ x: 0, y: 0 });

// Broadcast-Status Tracking
const participantBroadcastStatusMap = ref(new Map());
const currentInlineVideoIdentity = ref(null);

// Präsentations-Refs
const slideShowNumber = ref(5); // Webinar Nummer
const presentationStarted = ref(false);
const presentationView = ref('inline'); // 'inline' oder 'standard'
const audienceVideoInline = ref(null);
const showDebug = ref(false);

const webinarStats = ref({
  fragen: 0,
  danke: 0,
  interessant: 0,
});

const startButtonPressed = ref(false);
// Reaktions-Animation über Admin-Video
const reactionAnimation = ref({
  visible: false,
  icon: '',
  color: ''
});

// Slides für aktuelles Webinar
const currentWebinarSlides = computed(() => {
  return webinarStore.pictureBroadCast && webinarStore.pictureBroadCast[slideShowNumber.value] 
    ? webinarStore.pictureBroadCast[slideShowNumber.value] 
    : {};
});

const activePictureBroadCast = ref({
  url: currentWebinarSlides.value && currentWebinarSlides.value[1] ? currentWebinarSlides.value[1].url : '',
  type: currentWebinarSlides.value && currentWebinarSlides.value[1] ? currentWebinarSlides.value[1].type : 'picture'
});


const audience = ref([]);
const fragen = ref(false);
// Fragenliste ohne Antworten von Dozent/Admin (die stehen nur im Chat)
const teilnehmerFragen = computed(() => (Array.isArray(fragen.value) ? fragen.value : []).filter(f => !f.team));

const dankeText = ref('');
const dankeSent = ref(false);

// Initial-Flag für Chat-History aus wtb_webinar_fragen
const initialChatLoaded = ref(false);

async function sendDanke() {
  let data = {
    action: 'sendDanke',
    danke_text: dankeText.value,
    danke_wteil_id: route.params.teilnahmeid,
    danke_wter_id: userWebinarTerminId.value,
    danke_webi_id: terminData.value.webi_id,
  }
  console.log('sendDanke', data);
  loaderStore.setLoader(true, "Ihre Meinung wird gesendet...");
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    dankeText.value = '';
    dankeSent.value = true;
    loaderStore.setLoader(false);
    successStore.setSuccess(true, 'Ihre Meinung wurde gespeichert', 'Danke für Ihre Meinung');
    sendDataMessage({ type: 'userDanke',from: myIdentity.value,ts: Date.now() });
    showDankeDialog.value = false;
  }
}

// Computed Style für Fragen Overlay
const fragenOverlayStyle = computed(() => ({
  display: fragenOverlayVisible.value ? 'block' : 'none',
  position: 'fixed',
  left: fragenOverlayPosition.value.x + 'px',
  top: fragenOverlayPosition.value.y + 'px',
  zIndex: 1000,
  minWidth: '600px',
  maxWidth: '800px',
  maxHeight: '90vh',
  height: 'auto'
}));

// Computed Style für Active Fragen Overlay
const activeFragenOverlayStyle = computed(() => ({
  display: activeFragenOverlayVisible.value ? 'block' : 'none',
  position: 'fixed',
  left: activeFragenOverlayPosition.value.x + 'px',
  top: activeFragenOverlayPosition.value.y + 'px',
  zIndex: 1000,
  minWidth: '800px',
  maxWidth: '900px',
  maxHeight: '90vh',
  height: 'auto',
  minHeight: '300px'
}));

// Helper computed um zu prüfen ob ein User online ist
const isUserOnline = computed(() => {
  return (id) => {
    const identity = 'audience_' + id;
    console.log('Prüfe User Online in allTeilnehmerInRoom:', id, '→', identity);
    
    // Durchsuche allTeilnehmerInRoom nach dem User
    const foundUser = allTeilnehmerInRoom.value.find(participant => 
      participant.identity === identity && participant.state === 'connected'
    );
    
    if (foundUser) {
      console.log('User ist online (gefunden in allTeilnehmerInRoom):', identity);
      return true;
    }
    
    console.log('User ist offline (nicht in allTeilnehmerInRoom gefunden):', identity);
    return false;
  };
});

// Overlay Drag-Funktionen
function startFragenDrag(event) {
  fragenIsDragging.value = true;
  fragenDragStart.value = {
    x: event.clientX - fragenOverlayPosition.value.x,
    y: event.clientY - fragenOverlayPosition.value.y
  };
  document.addEventListener('mousemove', handleFragenDrag);
  document.addEventListener('mouseup', stopFragenDrag);
  event.preventDefault();
}

function handleFragenDrag(event) {
  if (!fragenIsDragging.value) return;
  fragenOverlayPosition.value = {
    x: Math.max(0, Math.min(window.innerWidth - 400, event.clientX - fragenDragStart.value.x)),
    y: Math.max(0, Math.min(window.innerHeight - 200, event.clientY - fragenDragStart.value.y))
  };
}

function stopFragenDrag() {
  fragenIsDragging.value = false;
  document.removeEventListener('mousemove', handleFragenDrag);
  document.removeEventListener('mouseup', stopFragenDrag);
}

function toggleFragenOverlay() {
  fragenOverlayMinimized.value = !fragenOverlayMinimized.value;
}

// Active Fragen Overlay Drag Funktionen
function startActiveFragenDrag(event) {
  activeFragenIsDragging.value = true;
  activeFragenDragStart.value = {
    x: event.clientX - activeFragenOverlayPosition.value.x,
    y: event.clientY - activeFragenOverlayPosition.value.y
  };
  
  document.addEventListener('mousemove', handleActiveFragenDrag);
  document.addEventListener('mouseup', stopActiveFragenDrag);
  event.preventDefault();
}

function handleActiveFragenDrag(event) {
  if (!activeFragenIsDragging.value) return;
  
  activeFragenOverlayPosition.value = {
    x: Math.max(0, Math.min(window.innerWidth - 500, event.clientX - activeFragenDragStart.value.x)),
    y: Math.max(0, Math.min(window.innerHeight - 200, event.clientY - activeFragenDragStart.value.y))
  };
}

function stopActiveFragenDrag() {
  activeFragenIsDragging.value = false;
  document.removeEventListener('mousemove', handleActiveFragenDrag);
  document.removeEventListener('mouseup', stopActiveFragenDrag);
}

function toggleActiveFragenOverlay() {
  activeFragenOverlayMinimized.value = !activeFragenOverlayMinimized.value;
}

// Broadcast-Status Funktionen
function evaluateParticipantBroadcastStatus(participant) {
  try {
    const hasVideo = Array.from(participant.videoTracks?.values?.() || []).some(pub => !!pub.track);
    const hasAudio = Array.from(participant.audioTracks?.values?.() || []).some(pub => !!pub.track);
    const isBroadcasting = hasVideo || hasAudio;
    participantBroadcastStatusMap.value.set(participant.identity, {
      hasVideo,
      hasAudio,
      isBroadcasting
    });
    console.log('📡 BroadcastStatus', participant.identity, { hasVideo, hasAudio, isBroadcasting });
  } catch (e) {
    console.warn('evaluateParticipantBroadcastStatus failed for', participant.identity, e);
  }
}

function getParticipantsBroadcastStatus() {
  const list = [];
  if (!room.value) return list;
  room.value.participants.forEach(p => {
    const status = participantBroadcastStatusMap.value.get(p.identity) || { hasVideo: false, hasAudio: false, isBroadcasting: false };
    list.push({ identity: p.identity, ...status });
  });
  const lp = room.value.localParticipant;
  if (lp) {
    const status = {
      hasVideo: Array.from(lp.videoTracks?.values?.() || []).some(pub => !!pub.track),
      hasAudio: Array.from(lp.audioTracks?.values?.() || []).some(pub => !!pub.track)
    };
    list.unshift({ identity: lp.identity, ...status, isBroadcasting: status.hasVideo || status.hasAudio });
  }
  return list;
}

async function setUserVideoOnDirect(video, item) {
  console.log('setUserVideoOnDirect', video, item);
  const identity = myIdentity.value;
  const toSend = item.identity;
  
  if (video == 0) {
    console.log('setUserVideoOff');
    sendDataMessage({ type: 'videoOff', to: toSend, from: identity, ts: Date.now() });
  } 
  if (video == 1) {
    console.log('setUserVideoOn');
    sendDataMessage({ type: 'videoOn', to: toSend, name: getNameFromTeilnehmer(item.identity, 'name'), from: identity, ts: Date.now() });
    sendDataMessage({ type: 'jetzLiveImWebinar', from: toSend, ts: Date.now() });
  }
}

function showInlineVideo(identity) {
  sendDataMessage({ type: 'showInlineVideo', identity: identity, ts: Date.now() });
}

function hideInlineVideo() {
  sendDataMessage({ type: 'hideInlineVideo', ts: Date.now() });
}

function toggleInlineVideo(identity) {
  if (currentInlineVideoIdentity.value === identity) {
    hideInlineVideo();
    currentInlineVideoIdentity.value = null;
  } else {
    showInlineVideo(identity);
    currentInlineVideoIdentity.value = identity;
  }
}

const isOpen = computed(() => {
  if(!terminData.value || !terminData.value.wter_beginn){
    return false;
  }
  if (terminData.value.beendet == 1) {
    return false;
  }
  if (terminData.value.open == false) {
    return false;
  }
    // Parse the wter_beginn string into a Date object
    const wterBeginnDate = new Date(terminData.value.wter_beginn);

    // Get the current time
    const now = new Date();

    // Calculate the start and end of the range
    const startRange = new Date(wterBeginnDate);
    startRange.setMinutes(startRange.getMinutes() - 10);

    const endRange = new Date(wterBeginnDate);
    endRange.setMinutes(endRange.getMinutes() + 180);
    console.log(now > startRange && now < endRange);
    // Check if the current time is within the range
    return true;

    //return now > startRange && now < endRange;
});
// Nur Audience-Teilnehmer (nicht Admin, nicht ich selbst)
const audienceParticipants = computed(() => {
  const myIdentity = `audience_${route.params.teilnahmeid}`;
  return allTeilnehmerInRoom.value.filter(p => 
    p.identity.startsWith('audience_') && 
    p.identity !== myIdentity &&
    !p.identity.startsWith('admin_')
  );
});

async function startWebinar() {
  startButtonPressed.value = true;
    await getToken();
  }

  async function getToken() {
  console.log('getToken');
 if (!isOpen.value) {
    console.log('Webinar ist nicht offen');
    loaderStore.setLoader(false);
    return;
  }
  let data = {
    action: 'getWebinarAudienceUserToken',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    admin: 0,
  }
  loaderStore.setLoader(true, "Das Webinar wird gestartet...");
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    token.value = response.data.token;
    userStore.setToken(response.data.token);
    userStore.setWebinarTerminId(response.data.terminId);
    webinarTerminId.value = response.data.terminId;

    console.log('✅ Token erfolgreich geholt, verbinde mit Room...');
    await joinRoom();
    
    // Warte kurz und prüfe ob Admin-Video da ist
    setTimeout(() => {
    loaderStore.setLoader(false);
      if (hasAdminVideo.value) {
        console.log('✅ Admin-Video wird angezeigt');
      } else {
        console.log('⚠️ Admin-Video noch nicht sichtbar, warte auf Stream...');
      }
    }, 2000);
  } else {
    loaderStore.setLoader(false);
    console.error('❌ Token konnte nicht geholt werden');
  }

}

async function getAudience() {
  try {
    let data = {
      action: 'getAudienceAll',
      id: terminData.value.wter_id,
    }
    console.log('getAudience', data)
    const response = await baseCalls.webinarPost(data);

    if (response.data.success == true) {
      audience.value = response.data.audience;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Audience:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler beim Laden der Audience');
    }
  }
}

async function getFragen() {
  console.log('getFragen');
  try {
    let data = {
      action: 'getFragen',
      id: terminData.value.wter_id,
    }
    const response = await baseCalls.webinarPost(data);
    if (response.data.success == true) {
      fragen.value = response.data.fragen;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Fragen:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler - versuche später erneut');
    }
  }
}

// Bestehende wtb_webinar_fragen beim Start einmalig in den Chat übernehmen (neueste zuerst)
watch(fragen, (newFragen) => {
  if (
    initialChatLoaded.value ||
    !Array.isArray(newFragen) ||
    newFragen.length === 0
  ) {
    return;
  }

  try {
    const mapped = newFragen.map((item) => ({
      from: 'audience_' + item.teilnehmerid,
      displayName: item.name,
      text: item.frage,
      ts: Date.now() - (item.vor || 0) * 60 * 1000,
    }));

    chatMessages.value = mapped;
    initialChatLoaded.value = true;
    console.log('✅ Initiale Chat-History (Admin) geladen:', mapped.length);
  } catch (e) {
    console.warn('Fehler beim Initial-Mappen der Fragen in den Admin-Chat:', e);
  }
}, { deep: true });

async function SetStatusFrage(status, item) {
  let data = {
    action: 'setStatusFrage',
    id: item.id,
    status: status,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    getFragen();
  }
}

async function setUserVideoOn(video, item) {
  let identity = myIdentity.value;
  let toSend = 'audience_' + item.teilnehmerid;
  
  if (video == 0) {
    console.log('setUserVideoOff');
    sendDataMessage({ type: 'videoOff', to: toSend, from: identity, ts: Date.now() });
  } 
  if (video == 1) {
    console.log('setUserVideoOn');
    sendDataMessage({ type: 'videoOn', to: toSend, name: getNameFromTeilnehmer(toSend, 'name'), from: identity, ts: Date.now() });
    sendDataMessage({ type: 'jetzLiveImWebinar', from: toSend, ts: Date.now() });
  }
  
  let data = {
    action: 'setUserVideoOn',
    id: item.teilnehmerid,
    video: video,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    getFragen();
  }
}

function getNameFromTeilnehmer(identity,what = 'name') {
  if(audience.value.length > 0) {
    // Extrahiert die Nummer nach dem Unterstrich: "audience_282" -> "282"
    const parts = identity.split('_');
    const id = parts[parts.length - 1]; // Nimmt das letzte Element nach dem Split
    console.log('getNameFromTeilnehmer', identity, '->', id);
    if(what == 'name') {
      return audience.value.find(item => item.wteil_id == id)?.wteil_pers_name || identity;
    }
    if(what == 'admin') {
      return audience.value.find(item => item.wteil_id == id)?.wteil_is_admin || false;
    }
  }
  return identity;
}

// Teilnehmerliste aktualisieren
function updateAllTeilnehmerInRoom() {
  if (!room.value || !room.value.participants) {
    allTeilnehmerInRoom.value = [];
    return;
  }
  
  console.log('🔄 Aktualisiere Teilnehmerliste');
  
  const participantsArray = Array.from(room.value.participants.values());
  const allParticipants = [room.value.localParticipant, ...participantsArray];
  
  allTeilnehmerInRoom.value = allParticipants.map(participant => ({
    identity: participant.identity,
    sid: participant.sid,
    state: participant.state,
    isLocal: participant === room.value.localParticipant,
    videoTracks: participant.videoTracks ? participant.videoTracks.size : 0,
    audioTracks: participant.audioTracks ? participant.audioTracks.size : 0,
    dataTracks: participant.dataTracks ? participant.dataTracks.size : 0
  }));
  
  console.log('👥 Teilnehmer:', allTeilnehmerInRoom.value.length);
}

// Participant-Handling
function setupParticipant(participant) {
  console.log('👤 Setup:', participant.identity);
  
  // Zuerst Teilnehmerliste aktualisieren, damit Container erstellt werden
  updateAllTeilnehmerInRoom();
  
  // Broadcast-Status initial bewerten
  evaluateParticipantBroadcastStatus(participant);
  
  participant.tracks.forEach(publication => {
    console.log('🔎 Publication gefunden:', publication.kind, publication.trackName, 'sid:', publication.trackSid, 'isSubscribed:', publication.isSubscribed);

    // Admin-Video ggf. proaktiv abonnieren
    if (publication.kind === 'video') {
      try {
        // Admin-Priorität hochsetzen
        if (participant.identity.startsWith('admin_') && typeof publication.setPriority === 'function') {
          publication.setPriority('high');
          console.log('⬆️ Priority high gesetzt für admin Video');
        }
      } catch (e) {
        console.warn('⚠️ setPriority fehlgeschlagen:', e);
      }
    }

    // Für Admin-Teilnehmer proaktiv abonnieren, falls möglich
    if (publication.kind === 'video' && participant.identity.startsWith('admin_')) {
      try {
        if (!publication.isSubscribed && typeof publication.subscribe === 'function') {
          console.log('📡 Versuche admin Video-Track zu abonnieren:', publication.trackSid);
          publication.subscribe();
        }
  } catch (e) {
        console.warn('⚠️ subscribe() auf Publication fehlgeschlagen:', e);
      }
    }

    if (publication.isSubscribed && publication.track) {
      console.log('📺 Bereits subscribed track:', publication.track.kind, participant.identity);
      attachTrack(publication.track, participant);
      if (publication.kind === 'video' && !participant.identity.startsWith('admin_')) {
        audienceIdentityHasVideo.value[participant.identity] = true;
      }
    }
    
    publication.on('subscribed', track => {
      console.log(`✅ Track subscribed: ${track.kind}`, participant.identity);
      attachTrack(track, participant);
      updateAllTeilnehmerInRoom();
      if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
        audienceIdentityHasVideo.value[participant.identity] = true;
      }
      evaluateParticipantBroadcastStatus(participant);
    });
    
    publication.on('unsubscribed', track => {
      console.log(`❌ Track unsubscribed: ${track.kind}`, participant.identity);
      detachTrack(track);
      updateAllTeilnehmerInRoom();
      if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
        audienceIdentityHasVideo.value[participant.identity] = false;
      }
      evaluateParticipantBroadcastStatus(participant);
    });
  });

  // Proaktives Binden existierender DataTracks (falls bereits subscribed)
  try {
    const dataPubs = Array.from(participant.dataTracks?.values?.() || []);
    dataPubs.forEach(pub => {
      if (pub && pub.track) {
        console.log('🔗 Binde vorhandenen DataTrack:', participant.identity, pub.track.sid);
        attachDataTrack(pub.track, participant);
      }
    });
  } catch (e) {
    console.warn('Proaktives DataTrack-Binden fehlgeschlagen:', e);
  }
  
  participant.on('trackPublished', publication => {
    console.log(`📤 Track published: ${publication.kind}`, participant.identity);
    
    // DataTrack publications proaktiv subscriben für Audience-zu-Audience Kommunikation
    if (publication.kind === 'data' && !publication.isSubscribed) {
      console.log('📡 DataTrack published, subscribiere proaktiv:', participant.identity);
      // Track wird automatisch subscribed durch automaticSubscription: true
      // Aber wir loggen es explizit für Debugging
    }
    
    updateAllTeilnehmerInRoom();
    evaluateParticipantBroadcastStatus(participant);
  });

  participant.on('trackSubscribed', track => {
    console.log(`🎥 trackSubscribed: ${track.kind}`, participant.identity);
    attachTrack(track, participant);
    updateAllTeilnehmerInRoom();
    if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
      audienceIdentityHasVideo.value[participant.identity] = true;
    }
    // DataTrack proaktiv binden (wichtig für Audience-zu-Audience Kommunikation)
    if (track.kind === 'data') {
      console.log('📡 DataTrack subscribed, binde explizit:', participant.identity);
      attachDataTrack(track, participant);
    }
    evaluateParticipantBroadcastStatus(participant);
  });

  participant.on('trackUnsubscribed', track => {
    console.log(`🚫 trackUnsubscribed: ${track.kind}`, participant.identity);
    detachTrack(track);
    updateAllTeilnehmerInRoom();
    if (track.kind === 'video' && !participant.identity.startsWith('admin_')) {
      audienceIdentityHasVideo.value[participant.identity] = false;
    }
    evaluateParticipantBroadcastStatus(participant);
      });
    }
 
function teardownParticipant(participant) {
  console.log('👋 Teardown:', participant.identity);
  const container = document.getElementById(`participant-${participant.sid}`);
  if (container) container.innerHTML = '';
}

// Track-Verwaltung
function attachTrack(track, participant) {
      if (track.kind === 'video') {
    attachVideoTrack(track, participant);
  } else if (track.kind === 'audio') {
    attachAudioTrack(track, participant);
  } else if (track.kind === 'data') {
    attachDataTrack(track, participant);
  }
}

async function attachVideoTrack(track, participant) {
  console.log('🎥 Attach video:', participant.identity, 'Track SID:', track.sid);
  
  // Warte auf Vue DOM-Update
  await nextTick();
  
  let container;
  let containerName;
  
      if (participant.identity.startsWith('admin_')) {
    // Admin-Video: Wähle Container basierend auf Präsentationsstatus
    if (presentationStarted.value) {
      containerName = 'admin-videos-inline';
    } else {
      containerName = 'admin-videos-fullsize';
    }
    container = document.getElementById(containerName);
    console.log('🎥 Admin-Video Container:', containerName);
  } else if (showInlineVideoIdentity.value === participant.identity) {
    // Audience-Video soll im Inline-Overlay (unten rechts) angezeigt werden
    // Wähle Container basierend auf Präsentationsstatus
    if (presentationStarted.value) {
      containerName = 'audience-video-inline';
    } else {
      containerName = 'audience-video-inline-fullsize';
    }
    container = document.getElementById(containerName);
    console.log('🎥 Audience-Video Inline Container:', containerName, 'Gefunden:', !!container);
  } else {
    containerName = `video-container-${participant.identity.replace('_', '-')}`;
    container = document.getElementById(containerName);
  }
  
  console.log('🔍 Suche Container:', containerName, 'Gefunden:', !!container);
  
  if (!container) {
    console.warn('❌ Container nicht gefunden für', participant.identity, containerName);
    
    // Warte kurz und versuche nochmal (Vue braucht Zeit für DOM-Update)
    setTimeout(async () => {
      await nextTick();
      const retryContainer = document.getElementById(containerName);
      if (retryContainer) {
        console.log('✅ Container nach Retry gefunden:', containerName);
        attachVideoToContainer(track, participant, retryContainer);
      } else {
        console.error('❌ Container auch nach Retry nicht gefunden:', containerName);
      }
    }, 300);
    return;
  }
  
  attachVideoToContainer(track, participant, container);
}

function attachVideoToContainer(track, participant, container) {
  // Wenn ein Vue-Container verwendet wird, .video-area als Ziel nutzen
  const target = container.querySelector('.video-area') || container;
  const existing = target.querySelector(`[data-track-id="${track.sid}"]`);
  if (existing) {
    console.log('🔄 Video bereits vorhanden');
      return;
    }
    
  console.log('📹 Erstelle Video-Element für:', participant.identity);

  const el = track.attach();
  el.setAttribute('data-track-id', track.sid);
  el.setAttribute('data-participant-identity', participant.identity);
        el.style.width = '100%';
        el.style.height = '100%';
        el.style.objectFit = 'cover';
        el.style.borderRadius = '0px';
  el.autoplay = true;
  el.playsInline = true;
  // Alle Remote-Videos stumm schalten, um Autoplay-Blocker zu vermeiden
  el.muted = true;
  
  // Explizit play() aufrufen, falls autoplay nicht funktioniert
  el.play().catch(err => {
    console.warn('⚠️ Video play() fehlgeschlagen:', err);
    // Wenn play() fehlschlägt, nochmal mit muted versuchen
    el.muted = true;
    el.play().catch(e => console.error('❌ Video play() final gescheitert:', e));
  });

  // Für Nicht-Admin nur einen Track zeigen: Container leeren
  if (!participant.identity.startsWith('admin_')) {
    // Entferne nur zuvor eingefügte Track-Elemente, nicht den gesamten Vue-Inhalt
    Array.from(target.querySelectorAll('[data-track-id]')).forEach(n => n.remove());
  }

  // Admin-Video einfügen (direkt in Container - fullsize oder inline)
  if (participant.identity.startsWith('admin_')) {
    // Entferne nur zuvor eingefügte Track-Elemente, nicht den gesamten Vue-Inhalt
    Array.from(target.querySelectorAll('[data-track-id]')).forEach(n => n.remove());
  }
  target.appendChild(el);

  // Markiere, dass dieser Participant ein Video hat
  if (!participant.identity.startsWith('admin_')) {
    audienceIdentityHasVideo.value[participant.identity] = true;
  } else {
    // Admin hat Video gestartet
    hasAdminVideo.value = true;
  }

  console.log('✅ Video angezeigt in:', (target.id || container.id), 'Size:', el.videoWidth, 'x', el.videoHeight);

  // Debug nach 1 Sekunde
          setTimeout(() => {
    console.log('🔍 Video Status nach 1s:', {
      container: container.id,
      videoWidth: el.videoWidth,
      videoHeight: el.videoHeight,
              readyState: el.readyState,
      paused: el.paused
            });
          }, 1000);
}

function attachAudioTrack(track, participant) {
  console.log('🎤 Attach audio:', participant.identity);
  
  const existing = document.querySelector(`[data-audio-track-id="${track.sid}"]`);
  if (existing) return;
  
  const audioEl = track.attach();
  audioEl.setAttribute('data-audio-track-id', track.sid);
  audioEl.setAttribute('data-participant-identity', participant.identity);
  audioEl.autoplay = true;
  audioEl.style.display = 'none';
  document.body.appendChild(audioEl);
  console.log('✅ Audio attached');
  
  // Markiere dass dieser Participant Audio hat (für Audio-Only Anzeige)
  if (!participant.identity.startsWith('admin_')) {
    audienceIdentityHasAudio.value[participant.identity] = true;
  }
}

function detachTrack(track) {
  console.log('🗑️ Detach track:', track.sid, track.kind);
  
  // Finde das Element über data-track-id oder data-audio-track-id
  const selector = track.kind === 'audio' 
    ? `[data-audio-track-id="${track.sid}"]`
    : `[data-track-id="${track.sid}"]`;
    
  const elements = document.querySelectorAll(selector);
  elements.forEach(el => {
    console.log('🗑️ Entferne Element:', el.tagName);
    const identity = el.getAttribute('data-participant-identity');
    if (identity) {
      if (!identity.startsWith('admin_')) {
        if (track.kind === 'video') {
          audienceIdentityHasVideo.value[identity] = false;
        } else if (track.kind === 'audio') {
          audienceIdentityHasAudio.value[identity] = false;
      }
    } else {
        // Admin Video wurde entfernt
        if (track.kind === 'video') {
          hasAdminVideo.value = false;
        }
      }
    }
    el.remove();
  });
}

function sendDataMessage(message) {
  const track = getMyDataTrack();
  if (!track) {
    console.warn('Kein lokaler DataTrack gefunden');
    return false;
  }
  try {
    const messageText = typeof message === 'string' ? message : JSON.stringify(message);
    track.send(messageText);
    console.log('📤 Gesendet:', message);

    // Gesendete Nachricht lokal zur Anzeige hinzufügen
    addDataTrackMessage({
      from: myIdentity.value,
      content: messageText
    });

    return true;
  } catch (e) {
    console.error('Senden fehlgeschlagen:', e);
    return false;
  }
}
function getMyDataTrack() {
  return localDataTrack.value || null;
}

// Hilfsfunktion: gesendete Nachricht in das bestehende Nachrichtenformat überführen
function addDataTrackMessage(msg) {
  try {
    const text = typeof msg === 'string' ? msg : (msg.content || '');
    let payload;
    try { payload = JSON.parse(text); } catch (_) { payload = { type: 'text', text }; }
    const newMessage = {
      from: msg.from || 'Sie',
      ts: Date.now(),
      payload
    };
    dataTrackMessages.value = [newMessage, ...dataTrackMessages.value];
  } catch (e) {
    console.warn('addDataTrackMessage fehlgeschlagen:', e);
  }
}

function addChatMessageFromPayload(payload) {
  if (!payload || payload.type !== 'chatMessage' || !payload.text) return;
  // Neueste Nachricht zuerst anzeigen
  chatMessages.value.unshift({
    from: payload.from,
    displayName: getNameFromTeilnehmer(payload.from, 'name'),
    text: payload.text,
    ts: payload.timestamp || payload.ts || Date.now()
  });
}

// Chat-Nachricht auch in wtb_webinar_fragen speichern
async function saveChatMessageToDb(text) {
  try {
    const data = {
      action: 'saveFrage',
      frage: text,
      terminid: terminData.value.wter_id,
      teilnehmerid: route.params.teilnahmeid,
    };
    await baseCalls.webinarPost(data);
  } catch (error) {
    console.error('Fehler beim Speichern der Chat-Nachricht:', error);
  }
}

// DataTrack Handling
function attachDataTrack(track, participant) {
  console.log('💬 Attach data track from', participant.identity, 'Track:', track);
  
  // Wenn bereits gebunden, nicht erneut binden
  if (track._eventListenersBound) {
    console.log('⚠️ DataTrack bereits gebunden für', participant.identity);
    return;
  }
  
  const handler = (msg) => {
    console.log('📩 RAW DataTrack message empfangen von', participant.identity, ':', msg);
    try {
      const text = typeof msg === 'string' ? msg : new TextDecoder().decode(msg);
      console.log('📩 DataTrack Text:', text);
      let parsed;
      try { parsed = JSON.parse(text); } catch (_) { parsed = { type: 'text', text }; }
      console.log('📩 DataTrack Parsed:', parsed);
      
      const newMessage = {
        from: participant.identity,
        ts: Date.now(),
        payload: parsed,
      };
      
      // Array neu zuweisen für bessere Reaktivität
      dataTrackMessages.value = [newMessage, ...dataTrackMessages.value];
      console.log('✅ DataTrack Message hinzugefügt. Anzahl:', dataTrackMessages.value.length);
      
      // Optional: Liste begrenzen
      if (dataTrackMessages.value.length > 200) {
        dataTrackMessages.value = dataTrackMessages.value.slice(0, 200);
      }
    } catch (e) {
      console.error('❌ DataTrack message parse error:', e);
    }
  };
  
  track.on('message', handler);
  console.log('✅ Event-Listener für DataTrack registriert:', participant.identity);
  
  // Markierung, um doppeltes Binden zu vermeiden
  track._eventListenersBound = true;
}

// Room Join
 async function joinRoom() {
  console.log('🔗 Joining room...');
  
  // Wenn bereits verbunden oder am Verbinden, abbrechen
  if (isConnected.value || isConnecting.value) {
    console.warn('⚠️ Bereits verbunden/verbindend - joinRoom abgebrochen');
    return;
  }

  // Falls ein alter Room noch existiert, sauber disconnecten
  if (room.value) {
    try {
      console.log('🔌 Alte Room-Verbindung wird geschlossen...');
      const oldRoom = room.value;
      room.value = null;
      isConnected.value = false;
      oldRoom.disconnect();
      // Warte bis Disconnect vollständig ist
      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (e) {
      console.warn('Fehler beim Disconnect alter Session:', e);
    }
  }
  
  isConnecting.value = true;

  const roomName = 'webinar_' + webinarTerminId.value;
  
  try {
    const dataTrack = new Video.LocalDataTrack({
        name: 'chat',
        ordered: true,
        reliable: true
      });
    localDataTrack.value = markRaw(dataTrack);
    
    const r = await Video.connect(token.value, { 
      name: roomName,
      // Identity kommt aus dem Token; nicht explizit überschreiben, um Duplikate zu verhindern
      tracks: [localDataTrack.value],
      audio: false,
      video: false,
      automaticSubscription: true,
      dominantSpeaker: false,
      preferredVideoCodecs: [{ codec: 'VP8', simulcast: false }],
      preferredAudioCodecs: ['opus'],
      bandwidthProfile: {
        video: {
          mode: 'presentation',
          maxTracks: 12,
          renderDimensions: {
            high: { width: 1280, height: 720 },
            standard: { width: 640, height: 360 },
            low: { width: 320, height: 180 }
          }
        }
      }
    });
    
    room.value = markRaw(r);
    isConnected.value = true;
    console.log('✅ Verbunden');
    
    // Warte bis LocalDataTrack published ist, dann sende Registrierungs-Message
    const sendRegistrationMessage = () => {
      console.log('📡 Sende Registrierungs-Nachricht');
      sendDataMessage({ type: 'newTeilnehmerRegistered', from: myIdentity.value, ts: Date.now() });
    };
    
    // Prüfe ob DataTrack bereits published ist
    const dataTrackPublished = Array.from(room.value.localParticipant.dataTracks.values()).length > 0;
    if (dataTrackPublished) {
      console.log('✅ DataTrack bereits published');
      sendRegistrationMessage();
    } else {
      // Warte auf trackPublished Event
      console.log('⏳ Warte auf DataTrack publish...');
      room.value.localParticipant.once('trackPublished', (publication) => {
        if (publication.kind === 'data') {
          console.log('✅ DataTrack published:', publication.trackSid);
          setTimeout(sendRegistrationMessage, 500); // Kurze Verzögerung für Stabilität
        }
      });
    }
    
    // Bereits vorhandene Teilnehmer
    const participants = Array.from(room.value.participants.values());
    console.log('👤 Teilnehmer:', participants.length);
    
    participants.forEach(participant => {
      setupParticipant(participant);
    });
    
    updateAllTeilnehmerInRoom();
    
    // Event Listener
    room.value.on('participantConnected', (participant) => {
      console.log('🔗 Participant joined:', participant.identity);
      setupParticipant(participant);
      updateAllTeilnehmerInRoom();

    // DataTracks sofort binden, wenn schon vorhanden
    try {
      const dataPubs = Array.from(participant.dataTracks?.values?.() || []);
      dataPubs.forEach(pub => {
        if (pub && pub.track) {
          console.log('🔗 (join) Binde vorhandenen DataTrack:', participant.identity, pub.track.sid);
          attachDataTrack(pub.track, participant);
        }
      });
    } catch (e) {
      console.warn('DataTrack-Bind (join) fehlgeschlagen:', e);
    }
    });
    
    room.value.on('participantDisconnected', (participant) => {
      console.log('🔌 Participant left:', participant.identity);
      teardownParticipant(participant);
      updateAllTeilnehmerInRoom();
    });

  // Raum-Disconnect behandeln
  room.value.on('disconnected', () => {
    console.log('🔌 Room disconnected');
    isConnected.value = false;
    isConnecting.value = false;
    room.value = null;
  });
  
  } catch (e) {
    console.error('❌ Connection error:', e);
  isConnected.value = false;
  room.value = null;
    isConnecting.value = false;
    // Bei Duplicate Identity: kurzen Backoff und erneut versuchen, falls die vorherige Session gerade schließt
    if (e && e.code === 53204 /* ParticipantDuplicateIdentityError */) {
      console.warn('Duplicate identity erkannt. Versuche erneut in 2s ...');
          setTimeout(() => {
        if (!isConnected.value && !isConnecting.value) {
          startSession();
        }
      }, 2000);
    }
  }
}

// Session Start
async function startSession() {
  console.log('🎬 Start session');
  console.log('  - userToken:', !!userToken.value);
  console.log('  - isConnected:', isConnected.value);
  
  if (userToken.value) {
    token.value = userToken.value;
    webinarTerminId.value = userWebinarTerminId.value;
    console.log('✅ Token vorhanden, verbinde...');
    
    if (!isConnected.value && !isConnecting.value) {
      isConnecting.value = true;
      await joinRoom();
      isConnecting.value = false;
  } else {
      console.log('⚠️ Bereits verbunden');
      }
    } else {
    console.log('⚠️ Kein Token, prüfe ob Token gesetzt ist...');
    await checkIfTokenIsSet();
  }
}

// Token holen
async function checkIfTokenIsSet() {
  if (isConnected.value || isConnecting.value) {
    console.warn('⚠️ checkIfTokenIsSet: bereits verbunden/verbindend');
    return;
  }
  
  const data = {
    action: 'checkIfTokenIsSet',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    admin: 0,
  };
  
  const response = await baseCalls.webinarPost(data);
  
  if (response.data.success) {
    token.value = response.data.token;
    userStore.setToken(response.data.token);
    userStore.setWebinarTerminId(response.data.terminId);
    webinarTerminId.value = response.data.terminId;
    
    if (!isConnected.value && !isConnecting.value) {
      await joinRoom();
    }
  }
}

// Termin-Daten laden
async function getTerminData() {
  const data = {
    action: 'getTerminDataDirect',
    id: route.params.teilnahmeid,
    terminid: route.params.terminid,
    hash: route.params.hash,
  };
  
  const response = await baseCalls.webinarPost(data);
  console.log('getTerminData', response.data);
  
  if (response.data.success) {
    terminData.value = response.data.terminData;
    
    if (terminData.value.open && !isConnected.value && !isConnecting.value) {
      userStore.setWebinarTerminId(terminData.value.id);
      await startSession();
      getAudience();
      getFragen();
      getWebinarStats();
    }
  }
}

// Watcher
watch(room, (newRoom) => {
  if (newRoom) {
    updateAllTeilnehmerInRoom();
  }
});

watch(() => terminData.value.open, (newValue) => {
  console.log('🔄 terminData.open:', newValue);
  if (newValue && !isConnected.value && !isConnecting.value) {
    startSession();
  }
});

// Watcher für presentationStarted - Video zwischen Containern verschieben
watch(presentationStarted, async (newValue, oldValue) => {
    if (slideShowNumber.value ==  0) {
      return false
    }
  console.log('🔄 presentationStarted changed:', oldValue, '->', newValue);
  
  if (presentationView.value === 'inline') {
    // Admin Video VOR Template-Switch retten
    let adminVideosToMove = [];
    
    const currentAdminContainer = oldValue ? 
      document.getElementById('admin-videos-inline') : 
      document.getElementById('admin-videos-fullsize');
    
    if (currentAdminContainer) {
      adminVideosToMove = Array.from(currentAdminContainer.querySelectorAll('video'));
      console.log('🎥 Admin-Videos vor Template-Switch gerettet:', adminVideosToMove.length);
    }
    
    // Audience Inline Video VOR Template-Switch retten
    let audienceInlineVideo = [];
    const currentAudienceInlineContainer = oldValue ?
      document.getElementById('audience-video-inline') :
      document.getElementById('audience-video-inline-fullsize');
      
    if (currentAudienceInlineContainer) {
      audienceInlineVideo = Array.from(currentAudienceInlineContainer.querySelectorAll('video'));
      console.log('🎥 Audience-Inline-Video vor Template-Switch gerettet:', audienceInlineVideo.length);
    }
    
    // Warten auf DOM-Update
    await nextTick();
    
    // Ziel-Container nach Template-Switch finden
    const newAdminContainer = newValue ? 
      document.getElementById('admin-videos-inline') : 
      document.getElementById('admin-videos-fullsize');
    
    const newAudienceInlineContainer = newValue ?
      document.getElementById('audience-video-inline') :
      document.getElementById('audience-video-inline-fullsize');
    
    // Gerettete Admin-Videos in neuen Container verschieben
    if (adminVideosToMove.length > 0 && newAdminContainer) {
      adminVideosToMove.forEach(video => {
        console.log('🎥 Verschiebe Admin-Video zu', newAdminContainer.id);
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        newAdminContainer.appendChild(video);
      });
      console.log('✅ Admin-Videos verschoben');
    }
    
    // Gerettete Audience-Inline-Videos verschieben
    if (audienceInlineVideo.length > 0 && newAudienceInlineContainer) {
      audienceInlineVideo.forEach(video => {
        console.log('🎥 Verschiebe Audience-Inline-Video zu', newAudienceInlineContainer.id);
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        newAudienceInlineContainer.appendChild(video);
      });
      console.log('✅ Audience-Inline-Video verschoben');
                    }
                  }
                });
                
watch(allTeilnehmerInRoom, (newList) => {
  console.log('📋 Teilnehmerliste geändert:', newList.length, 'Teilnehmer');
  newList.forEach(p => {
    console.log('  -', p.identity, '| Video:', p.videoTracks, '| Audio:', p.audioTracks);
  });
  // Sicherstellen, dass nur Teilnehmer mit Video angezeigt werden
  newList.forEach(p => {
    if (p.identity.startsWith('audience_')) {
    
      // Falls kein Video-Track registriert ist, flag zurücksetzen
      if (!p.videoTracks || p.videoTracks === 0) {
        audienceIdentityHasVideo.value[p.identity] = !!document.querySelector(`#video-container-${p.identity.replace('_','-')} [data-track-id]`);
      }
    }
  });
}, { deep: true });

// Watcher für showInlineVideoIdentity - Audience-Video in Inline-Overlay verschieben
watch(showInlineVideoIdentity, async (newIdentity, oldIdentity) => {
  console.log('🔄 showInlineVideoIdentity changed:', oldIdentity, '->', newIdentity);
  
  // Inline-Video funktioniert auch ohne Präsentation (dann im fullsize Container)
  if (!isConnected.value || !room.value) {
    console.log('⚠️ Nicht verbunden, kann Inline-Video nicht anzeigen');
    return;
  }
  
  // Altes Video zurück in normalen Container verschieben
  if (oldIdentity && room.value) {
    // Zuerst alle Video-Elemente des alten Participants aus Inline-Containern entfernen
    const oldInlineContainer = document.getElementById('audience-video-inline');
    const oldInlineFullsizeContainer = document.getElementById('audience-video-inline-fullsize');
    
    [oldInlineContainer, oldInlineFullsizeContainer].forEach(container => {
      if (container) {
        const videos = Array.from(container.querySelectorAll('video'));
        videos.forEach(v => {
          if (v.getAttribute('data-participant-identity') === oldIdentity) {
            console.log('🗑️ Entferne Video aus Inline-Container');
            v.remove();
          }
        });
      }
    });
    
    // Dann Video neu attachen in normalem Container
    const oldParticipant = Array.from(room.value.participants.values()).find(p => p.identity === oldIdentity);
    if (oldParticipant) {
      oldParticipant.videoTracks.forEach(pub => {
        if (pub.track) {
          console.log('🔄 Verschiebe altes Video zurück:', oldIdentity);
          attachVideoTrack(pub.track, oldParticipant);
        }
      });
    }
  }
  
  // Neues Video in Inline-Container verschieben
  if (newIdentity && room.value) {
    await nextTick();
    
    // Zuerst Video aus normalem Container entfernen
    const normalContainer = document.getElementById(`video-container-${newIdentity.replace('_', '-')}`);
    if (normalContainer) {
      const videoArea = normalContainer.querySelector('.video-area');
      if (videoArea) {
        const videos = Array.from(videoArea.querySelectorAll('video'));
        videos.forEach(v => {
          if (v.getAttribute('data-participant-identity') === newIdentity) {
            console.log('🗑️ Entferne Video aus normalem Container');
            v.remove();
          }
        });
      }
    }
    
    // Dann Video neu attachen in Inline-Container
    const newParticipant = Array.from(room.value.participants.values()).find(p => p.identity === newIdentity);
    if (newParticipant) {
      newParticipant.videoTracks.forEach(pub => {
        if (pub.track) {
          console.log('🔄 Verschiebe Video in Inline-Overlay:', newIdentity);
          attachVideoTrack(pub.track, newParticipant);
        }
      });
    }
  }
});

// Mounted
onMounted(() => {
  getTerminData();
  updateDocumentHead(
    "Webinar - Webinare für Zahnärzte & ZFA",
    "Webinare für Zahnärzte & ZFA"
  );
  
  // Keyboard shortcuts für Overlays
  const handleOverlayKeyboard = (event) => {
    // F1 = Teilnehmer Overlay toggle
    if (event.key === 'F1') {
      event.preventDefault();
      if (allTeilnehmerInRoom.value && allTeilnehmerInRoom.value.length > 0) {
        toggleFragenOverlay();
      }
    }
    // F2 = Fragen Overlay toggle
    if (event.key === 'F2') {
      event.preventDefault();
      if (fragen.value && fragen.value.length > 0) {
        toggleActiveFragenOverlay();
      }
    }
  };
  
  document.addEventListener('keydown', handleOverlayKeyboard);
  
  // Cleanup beim Unmount
  onBeforeUnmount(() => {
    document.removeEventListener('keydown', handleOverlayKeyboard);
  });
});

onBeforeUnmount(() => {
  try {
    if (room.value && typeof room.value.disconnect === 'function') {
      room.value.disconnect();
    }
      } catch (e) {
    console.warn('Fehler beim Disconnect auf Unmount:', e);
  }
});

// Helper
function hasVideo(identity) {
  return !!audienceIdentityHasVideo.value[identity];
}

function hasAudio(identity) {
  return !!audienceIdentityHasAudio.value[identity];
}

// Präsentations-Funktionen
function getUpcomingVideoSlides() {
  const slides = currentWebinarSlides.value;
  if (!slides || !activePictureBroadCast.value.url) return [];
  
  const currentIndex = Object.values(slides).findIndex(
    slide => slide.url === activePictureBroadCast.value.url
  );
  
  return Object.values(slides)
    .slice(currentIndex + 1, currentIndex + 4)
    .filter(slide => slide.type === 'video');
}

function getUpcomingImageSlides() {
  const slides = currentWebinarSlides.value;
  if (!slides || !activePictureBroadCast.value.url) return [];
  
  const currentIndex = Object.values(slides).findIndex(
    slide => slide.url === activePictureBroadCast.value.url
  );
  
  return Object.values(slides)
    .slice(currentIndex + 1, currentIndex + 4)
    .filter(slide => slide.type === 'picture');
}

// Mein Broadcast: Start/Stop und Attachment in #mein-broadcast
async function startMyBroadcast() {
  try {
    console.log('🎬 startMyBroadcast aufgerufen');
    if (!room.value) {
      console.warn('❌ startMyBroadcast: kein Room verbunden');
      return;
    }
    
    // Video-Track nur erstellen wenn NICHT audioOnlyBroadcast
    if (!audioOnlyBroadcast.value) {
      console.log('📹 Erstelle Video-Track...');
      if (!localVideoTrack.value) {
        const track = await Video.createLocalVideoTrack({
          name: `video_${myIdentity.value}`,
          width: 640,
          height: 480
        });
        localVideoTrack.value = markRaw(track);
        console.log('✅ Video-Track erstellt:', localVideoTrack.value.sid);
      }
    } else {
      console.log('🎤 Audio-Only Modus: Video wird NICHT erstellt');
    }
    
    console.log('🎤 Erstelle Audio-Track...');
    if (!localAudioTrack.value) {
      const audioTrack = await Video.createLocalAudioTrack({
        name: `audio_${myIdentity.value}`
      });
      localAudioTrack.value = markRaw(audioTrack);
      console.log('✅ Audio-Track erstellt:', localAudioTrack.value.sid);
    }
    
    // Publish Video falls noch nicht geschehen (NUR wenn nicht audioOnlyBroadcast)
    if (!audioOnlyBroadcast.value && localVideoTrack.value) {
      const alreadyPublishedVideo = Array.from(room.value.localParticipant.videoTracks.values()).some(pub => pub.track && pub.track.sid === localVideoTrack.value.sid);
      console.log('🔍 Video bereits publiziert?', alreadyPublishedVideo);
      
      if (!alreadyPublishedVideo) {
        console.log('📤 Veröffentliche Video-Track...');
        await room.value.localParticipant.publishTrack(localVideoTrack.value);
        console.log('✅ Video-Track veröffentlicht');
      }
    } else if (audioOnlyBroadcast.value) {
      console.log('🎤 Audio-Only Modus: Video wird NICHT publiziert');
    }
    
    // Publish Audio falls noch nicht geschehen
    const alreadyPublishedAudio = Array.from(room.value.localParticipant.audioTracks.values()).some(pub => pub.track && pub.track.sid === localAudioTrack.value.sid);
    console.log('🔍 Audio bereits publiziert?', alreadyPublishedAudio);
    
    if (!alreadyPublishedAudio) {
      console.log('📤 Veröffentliche Audio-Track...');
      await room.value.localParticipant.publishTrack(localAudioTrack.value);
      console.log('✅ Audio-Track veröffentlicht');
    }
    
    // Nach Publish: Warte kurz und prüfe
    await new Promise(resolve => setTimeout(resolve, 500));
    const videoTracksCount = room.value.localParticipant.videoTracks.size;
    const audioTracksCount = room.value.localParticipant.audioTracks.size;
    console.log('📊 Tracks nach Publish - Video:', videoTracksCount, 'Audio:', audioTracksCount);
    updateAllTeilnehmerInRoom();

    // WICHTIG: Flag ZUERST setzen, damit v-if den Container rendert
    isMyBroadcasting.value = true;
    
    // Warte auf Vue DOM-Update
    await nextTick();
    
    // In #mein-broadcast anhängen (NUR Video, wenn nicht audioOnlyBroadcast)
    if (!audioOnlyBroadcast.value && localVideoTrack.value) {
      const container = document.getElementById('mein-broadcast') || document.getElementById('mein-broadcast-mobile');
      if (container) {
        const el = localVideoTrack.value.attach();
        el.style.width = '100%';
        el.style.height = '100%';
        el.style.objectFit = 'cover';
        el.autoplay = true;
        el.playsInline = true;
        el.muted = true; // Eigenes Video stumm
        container.innerHTML = '';
        container.appendChild(el);
        console.log('✅ Video in #mein-broadcast angezeigt');
      } else {
        console.warn('❌ #mein-broadcast container nicht gefunden');
        isMyBroadcasting.value = false; // Zurücksetzen wenn Container nicht da
      }
    } else if (audioOnlyBroadcast.value) {
      console.log('🎤 Audio-Only Modus: "Audio Live" Indikator wird angezeigt');
    }
  } catch (e) {
    console.error('❌ startMyBroadcast Fehler:', e);
    isMyBroadcasting.value = false;
  }
}

async function stopMyBroadcast() {
  try {
    console.log('⏹️ stopMyBroadcast aufgerufen');
    
    // Video-Track unpublish und stoppen
    if (room.value && localVideoTrack.value) {
      try {
        console.log('📤 Unpublish Video-Track...');
        await room.value.localParticipant.unpublishTrack(localVideoTrack.value);
        console.log('✅ Video-Track unpublished');
        
        // Track stoppen (Kamera freigeben)
        localVideoTrack.value.stop();
        localVideoTrack.value = null;
        console.log('🎥 Video-Track gestoppt');
	} catch (e) {
        console.warn('⚠️ Video unpublish/stop fehlgeschlagen:', e);
      }
    }
    
    // Audio-Track unpublish und stoppen
    if (room.value && localAudioTrack.value) {
      try {
        console.log('📤 Unpublish Audio-Track...');
        await room.value.localParticipant.unpublishTrack(localAudioTrack.value);
        console.log('✅ Audio-Track unpublished');
        
        // Track stoppen (Mikrofon freigeben)
        localAudioTrack.value.stop();
        localAudioTrack.value = null;
        console.log('🎤 Audio-Track gestoppt');
		} catch (e) {
        console.warn('⚠️ Audio unpublish/stop fehlgeschlagen:', e);
      }
    }
    
    // WICHTIG: Flag ZUERST auf false setzen, damit v-if den Container ausblendet
    isMyBroadcasting.value = false;
    
    // Container leeren (falls noch sichtbar) - beide Container prüfen
    const containerDesktop = document.getElementById('mein-broadcast');
    const containerMobile = document.getElementById('mein-broadcast-mobile');
    
    if (containerDesktop) {
      containerDesktop.innerHTML = '';
      console.log('🗑️ Desktop Container geleert');
    }
    if (containerMobile) {
      containerMobile.innerHTML = '';
      console.log('🗑️ Mobile Container geleert');
    }
    
    updateAllTeilnehmerInRoom();
    console.log('✅ Mein Broadcast gestoppt - Kamera & Mikrofon freigegeben, Container ausgeblendet');
  } catch (e) {
    console.warn('❌ stopMyBroadcast Fehler:', e);
  }
}

function sendReactionPilot(type) {
  console.log('👍 Sende Reaktion:', type);
  const reactionMessage = {
    type: type,
    from: myIdentity.value,
    timestamp: Date.now()
  };
  sendDataMessage(reactionMessage);
}

function sendChatMessage() {
  const text = chatInput.value.trim();
  if (!text) return;

  const payload = {
    type: 'chatMessage',
    from: myIdentity.value,
    text,
    timestamp: Date.now()
  };

  // nur über DataTrack versenden – Anzeige läuft über addDataTrackMessage/addChatMessageFromPayload
  sendDataMessage(payload);
  saveChatMessageToDb(text);
  chatInput.value = '';
}

// Reaktionen senden
function sendReaction(type) {
  console.log('👍 Sende Reaktion:', type);
  const reactionMessage = {
    type: type,
    from: myIdentity.value,
    timestamp: Date.now()
  };
  sendDataMessage(reactionMessage);
  
  saveReaction(type);
  
  // Zeige Reaktions-Animation über Admin-Video
  showReactionAnimation(type);
  
  // Visuelles Feedback
  // Optional: Toast/Snackbar anzeigen
  console.log(`✅ Reaktion "${type}" gesendet`);
}

async function saveFrage() {
  showReactionAnimation('frage');
  loaderStore.setLoader(true, "Ihre Frage wird gespeichert...");
  let data = {
    action: 'saveFrage',
    frage: frageTexte.value,
    terminid: terminData.value.wter_id,
    teilnehmerid: route.params.teilnahmeid,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    // Erste Message: Benachrichtigung an alle Teilnehmer
    const reactionMessage = {
      type: 'neueUserFragen',
      from: myIdentity.value,
      timestamp: Date.now()
    };
    sendDataMessage(reactionMessage);
    
    // Kurze Verzögerung vor der zweiten Message (damit Watcher beide verarbeiten kann)
    setTimeout(() => {
      sendDataMessage({ type: 'neueFragen', identity: myIdentity.value, ts: Date.now() });
    }, 150);
    
    // Dialog schließen und Formular zurücksetzen
    showFrageDialog.value = false;
    frageTexte.value = '';
    loaderStore.setLoader(false);
    
    // Stats aktualisieren
    getWebinarStats();
  }
}

// Reaktions-Animation über Admin-Video anzeigen
function showReactionAnimation(type) {
  let icon = '';
  let color = '';
  
  switch(type) {
    case 'userDanke':
      icon = 'mdi-heart';
      color = '#F44336'; // rot
      break;
    case 'userInteressant':
      icon = 'mdi-fire';
      color = '#FF9800'; // orange
      break;
    case 'frage':
      icon = 'mdi-help-circle';
      color = '#2196F3'; // blau
      break;
    case 'userHallo':
      icon = 'mdi-human-greeting';
      color = '#2196F3'; // blau
      break;
  }
  
  // Animation einblenden
  reactionAnimation.value = {
    visible: true,
    icon: icon,
    color: color
  };
  
  // Nach 1 Sekunde wieder ausblenden
  setTimeout(() => {
    reactionAnimation.value.visible = false;
  }, 1000);
}

async function saveReaction(type) {
  let dataType = 0;
  if(type == 'userDanke') {
    dataType = 1;
  } else if(type == 'userInteressant') {
    dataType = 2;
  } else if(type == 'userHallo') {
    dataType = 3;
  }
  let data = {
    action: 'saveReaction',
    type: dataType,
    terminid: terminData.value.wter_id,
    teilnehmerid: route.params.teilnahmeid,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    console.log('✅ Reaktion gespeichert');
    getWebinarStats();
  } else {
    console.log('❌ Reaktion nicht gespeichert');
  }
}

async function getWebinarStats() {
  console.log('getWebinarStats');
  try {
    let data = {
      action: 'getWebinarStats',
      id: terminData.value.wter_id,
    }
    const response = await baseCalls.webinarPost(data);
    if (response.data.success == true) {
      webinarStats.value = response.data.stats;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Fragen:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler - versuche später erneut');
      // Optional: Benachrichtigung für den User
    }
  }
}

// Watch DataTrack messages: videoOn/videoOff an mich
watch(dataTrackMessages, (list) => {
  console.log('🔍 DataTrack Nachrichten:', list);
  if (!list || list.length === 0) return;
  const newest = list[0];
  const payload = newest && newest.payload ? newest.payload : null;
  console.log('🔍 DataTrack Nachricht empfangen:', payload);
  if (!payload || !payload.type) return;

  if(payload.type === 'showDankeDialog') {
    showDankeDialog.value = true;
  }

  if (payload.type === 'newTeilnehmerRegistered') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 Neuer Teilnehmer registriert:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'newTeilnehmerRegistered', from: payload.from || '' });
  
  }
  if (payload.type === 'jetzLiveImWebinar') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 Teilnehmer live zugeschaltet:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'jetzLiveImWebinar', from: payload.from || '' });
  
  }
  if (payload.type === 'userDanke') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 User Danke:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'userDanke', from: payload.from || '' });
  
  }
  if (payload.type === 'userHallo') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 User Hallo:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'userHallo', from: payload.from || '' });
  
  }
  if (payload.type === 'userInteressant') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 User Interessant:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'userInteressant', from: payload.from || '' });
  
  }
  if (payload.type === 'neueUserFragen') {
    // Nur fremde Teilnehmer-Registrierungen anzeigen, nicht eigene
      console.log('🔍 Neue Frage:', payload.from);
      publicDataTrackMessages.value.unshift({ type: 'neueUserFragen', from: payload.from || '' });
      getFragen();
  }
  if (payload.type === 'neueFragen') {
    console.log('🔍 Neue Frage Signal empfangen, lade Fragen neu');
    getFragen();
  }
  if (payload.type === 'chatMessage') {
    console.log('💬 Chat-Nachricht empfangen:', payload);
    addChatMessageFromPayload(payload);
  }
  // Präsentations-Messages (global, für alle)
  if (payload.type === 'pictureBroadCastStarted') {
    presentationStarted.value = true;
    console.log('📊 Präsentation gestartet');
  } else if (payload.type === 'pictureBroadCastEnded') {
    presentationStarted.value = false;
    showInlineVideoIdentity.value = null; // Inline-Video ausblenden
    console.log('📊 Präsentation beendet');
  } else if (payload.type === 'pictureBroadCast') {
    presentationStarted.value = true;
    if (payload.picture) {
      activePictureBroadCast.value.url = payload.picture.url;
      activePictureBroadCast.value.type = payload.picture.type;
      console.log('📊 Slide geändert:', payload.picture.url, payload.picture.type);
    }
  } else if (payload.type === 'showInlineVideo') {
    // Zeige Audience-Video im Inline-Overlay
    if (payload.identity && payload.identity !== myIdentity.value) {
      console.log('📺 Setze showInlineVideoIdentity:', payload.identity);
      console.log('  - presentationStarted:', presentationStarted.value);
      console.log('  - isConnected:', isConnected.value);
      showInlineVideoIdentity.value = payload.identity;
      console.log('  - showInlineVideoIdentity gesetzt auf:', showInlineVideoIdentity.value);
    } else {
      console.log('⏭️ Ignoriere showInlineVideo für eigene Identity');
    }
  } else if (payload.type === 'hideInlineVideo') {
    // Verstecke Inline-Video
    showInlineVideoIdentity.value = null;
    console.log('📺 Verstecke Inline-Video');
  }
  
  // Audience-spezifische Messages (nur für mich)
  const altTargets = [
    myIdentity.value,
    String(route.params.teilnahmeid),
    `audience_${String(route.params.teilnahmeid)}`
  ];
  if (payload.to && altTargets.includes(String(payload.to))) {
    console.log('🔍 DataTrack Nachricht empfangen:', payload.type);
    if (payload.type === 'videoOn') {
      console.log('🔍 Teilnehmer wird gebroadcastet:', payload.identity);
      if (!isMyBroadcasting.value) startMyBroadcast();
    } else if (payload.type === 'videoOff') {
      stopMyBroadcast();
    }
  }
}, { immediate: true });
</script>

<style scoped>
/* Alle Rundungen entfernen */
.v-card,
.v-btn,
.v-chip {
  border-radius: 0 !important;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.pulse-animation {
  animation: pulse 2s ease-in-out infinite;
}

/* Reaktions-Animation */
.reaction-fade-enter-active, .reaction-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.reaction-fade-enter-from {
  opacity: 0;
  transform: scale(0.5);
}

.reaction-fade-leave-to {
  opacity: 0;
  transform: scale(1.5);
}

.reaction-pulse {
  animation: reaction-pulse 1s ease-in-out;
}

@keyframes reaction-pulse {
  0% { 
    transform: scale(0.5); 
    opacity: 0; 
  }
  50% { 
    transform: scale(1.1); 
    opacity: 1; 
  }
  100% { 
    transform: scale(1); 
    opacity: 1; 
  }
}

/* Responsive Design für Mobile */
@media (max-width: 768px) {
  /* Kleinere Overlays auf Mobile */
  #audience-video-inline,
  #audience-video-inline-fullsize {
    width: 120px !important;
    height: 90px !important;
    bottom: 10px !important;
    right: 10px !important;
  }
  
  #admin-videos-inline {
    width: 120px !important;
    height: 90px !important;
    top: 10px !important;
    right: 10px !important;
  }
}

/* Draggable Overlay Styles */
.draggable-fragen-overlay {
  background: white;
  border: 2px solid #3d1b70;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  overflow: hidden;
  user-select: none;
}

.fragen-overlay-header {
  background: #3d1b70;
  color: white;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: move;
  font-weight: bold;
  font-size: 16px;
}

.fragen-overlay-minimize {
  background: none !important;
  box-shadow: none !important;
}

.fragen-overlay-minimize:hover {
  background: rgba(255,255,255,0.2) !important;
}

.fragen-overlay-content {
  max-height: calc(90vh - 35px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
  height: auto;
  min-height: fit-content;
  scrollbar-width: thin;
  scrollbar-color: #3d1b70 #f1f1f1;
}

.fragen-overlay-content::-webkit-scrollbar {
  width: 8px;
}

.fragen-overlay-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0;
}

.fragen-overlay-content::-webkit-scrollbar-thumb {
  background: #3d1b70;
  border-radius: 0;
}

.fragen-overlay-content::-webkit-scrollbar-thumb:hover {
  background: #fcc25e;
}

/* Draggable Active Fragen Overlay Styles */
.draggable-active-fragen-overlay {
  background: white;
  border: 2px solid #FF9800;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  overflow: hidden;
  user-select: none;
}

.active-fragen-overlay-header {
  background: #FF9800;
  color: white;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: move;
  font-weight: bold;
  font-size: 16px;
}

.active-fragen-overlay-minimize {
  background: none !important;
  box-shadow: none !important;
}

.active-fragen-overlay-minimize:hover {
  background: rgba(255,255,255,0.2) !important;
}

.active-fragen-overlay-content {
  max-height: calc(90vh - 35px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 15px;
  height: auto;
  min-height: 200px;
  scrollbar-width: thin;
  scrollbar-color: #FF9800 #f1f1f1;
}

.active-fragen-overlay-content::-webkit-scrollbar {
  width: 8px;
}

.active-fragen-overlay-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0;
}

.active-fragen-overlay-content::-webkit-scrollbar-thumb {
  background: #FF9800;
  border-radius: 0;
}

.active-fragen-overlay-content::-webkit-scrollbar-thumb:hover {
  background: #F57C00;
}

/* Pulsing Animation für Video Icon */
@keyframes pulse-heart {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.pulsing-heart {
  animation: pulse-heart 1s ease-in-out infinite;
}

/* Chat Styles */
.chat-message {
  border-bottom: 1px solid #eee;
  padding: 6px 8px;
}

.chat-message--me {
  background-color: #e8f5e9; /* helles Grün */
  border-left: 4px solid #4CAF50;
}
</style>
